enum BookingRoleWorkerSource {
    ManualAgency		= 1,
	ManualCompany	    = 2,
	ManualWorker    	= 3,
	System              = 4,
	SystemFavourites    = 5,
}

export default BookingRoleWorkerSource;
